import React from "react"
import { connect } from "react-redux"
import InputGroup from "../InputGroup/InputGroup"

const BiographyMotivates = (props) => {
  // Determine which data source to use based on URL or props
  const isProfileUrl = window.location.href.includes('/profile')
  const isSpouseUrl = window.location.href.includes('spouse')
  const isNonDodIcUrl = window.location.href.includes('non-dod-ic')
  const isAlliedForcesUrl = window.location.href.includes('allied-forces')

  let application = null
  if (isProfileUrl) {
    // For profile pages, use user data (create a copy to avoid mutating Redux state)
    application = props.user ? { ...props.user } : {}
  } else {
    // For application pages, use appropriate application data
    application = props.application
    if (isSpouseUrl && props.spouseApplication) {
      application = props.spouseApplication
    } else if (isNonDodIcUrl && props.nonDodIcApplication) {
      application = props.nonDodIcApplication
    } else if (isAlliedForcesUrl && props.alliedForcesApplication) {
      application = props.alliedForcesApplication
    }
  }
  const data = [
    {
      id: 'biography',
      inputType: "longText",
      defaultValue: `A good biography should be approximately 150 words in length and may include the duration of your service, key leadership positions, future career interests, your current timeline for transition, what you would like to get out of the COMMIT experience, and any personal details you would like to highlight. Your bio will be shared with COMMIT mentors. Please write in the third person and avoid references to specific ranks, awards, or units. (minimum 300 characters and maximum 1000 characters)`,
      placeholder: `What motivates you?`,
      charLimit: 1000,
      userField: "biography.motivations",
      title: `Biograpy`,
      required: true,
    }
  ]

  Object.byString = function (o, s) {
    if (!o || typeof o !== 'object') return undefined
    s = s.replace(/\[(\w+)\]/g, ".$1") // convert indexes to properties
    s = s.replace(/^\./, "") // strip a leading dot
    const a = s.split(".")
    for (let i = 0, n = a.length; i < n; ++i) {
      const k = a[i]
      if (o && typeof o === 'object' && k in o) {
        o = o[k]
      } else {
        return undefined
      }
    }
    return o
  }

  // Ensure application exists and has proper structure
  if (!application) {
    return null
  }

  // Ensure biography structure exists
  if (!application.biography) {
    application.biography = {}
  }

  const inputDataWithValues = data.map((input) => {
    // Use the determined application data source, fallback to props.user for profile pages
    const dataSource = isProfileUrl ? (application || props.user || {}) : (application || {})
    return {
      ...input,
      value: Object.byString(dataSource, input.userField) || ""
    }
  })

  // Ensure renderComponent exists before rendering
  if (!props.renderComponent || typeof props.renderComponent !== 'function') {
    return null
  }

  // Extract renderComponent to avoid passing undefined via spread
  const { renderComponent, ...otherProps } = props
  
  try {
    return (
      <InputGroup
        {...otherProps}
        inputData={inputDataWithValues}
      renderComponent={({ inputComponent, inputData, checkSubmittability }) => {
        if (!renderComponent || typeof renderComponent !== 'function') {
          return null
        }
        return (
          <>
            {renderComponent({
              ...otherProps,
              inputData,
              inputComponent,
              checkSubmittability
            })}
          </>
        )
      }}
      />
    )
  } catch (error) {
    return null
  }
}

const mapStateToProps = (state, props) => {
  return {
    ...props,
    application: state.application?.application || null,
    spouseApplication: state.spouseApplication?.application || null,
    nonDodIcApplication: state.nonDodIcApplication?.application || null,
    alliedForcesApplication: state.alliedForcesApplication?.application || null,
    user: state.user?.user || null
  }
}

export default connect(mapStateToProps)(BiographyMotivates)
